
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import Moment from "react-moment";
import { Modal } from "react-bootstrap";
import { useEffect } from "react";


export default function NgayPhep() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('usertype=1');

    const [fullname, setFullname] = useState('');
    const [code, setCode] = useState('');
    const [email, setEmail] = useState("");
    const [filterShow, setFilterShow] = useState(false)
    const [loading, setLoading] = useState(false)
    const [modalPhep, setModalPhep] = useState(false)
    const [selectID, setSelectID] = useState(0)
    const [listHistory, setListHistory] = useState([])



    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = 'status=1'
        if (fullname !== '') _param += "&fullname=" + fullname
        if (code !== '') _param += "&code=" + code
        if (email !== '') _param += "&email=" + email
        // console.log(_param);
        setParam(_param);
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        {
            name: "fullname", label: "Thông tin",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="mw-sm-300">
                        Họ tên: <strong>{value}</strong><br />
                        Mã nhân viên: <strong>{tableMeta.code}</strong><br />
                        Chức vụ: <strong>{tableMeta.chucvu} {tableMeta.bac ? <>({tableMeta.bac})</> : ''}</strong><br />
                        Phòng ban: <strong>{tableMeta.part_title}</strong><br />
                        Công ty: <strong>{tableMeta.company}</strong><br />
                    </div>
                },
            }
        },
        {
            name: "sophepcon", label: "Số phép còn lại",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div style={{ minWidth: 200 }}>
                        {value}
                    </div>
                },
            }
        },
        {
            name: "lichsuphep", label: "Lịch sử",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div style={{ minWidth: 200 }}>
                        <button type="button" className="btn btn-sm btn-warning" onClick={()=> {
                            setSelectID(tableMeta.id)
                            setModalPhep(true)
                        }}>Xem lịch sử</button>
                    </div>
                },
            }
        },
        { name: "datecreate", label: "Ngày tạo" },
        { name: "author", label: "Người tạo" },

    ];

    useEffect(function () {
        if (selectID > 0) {
            setLoading(true)
            Axios.get(URL_LIST_ALL + "ngayphep?user_id=" + selectID, user.config).then(async (res) => {
                setLoading(false)
                if (res.data.status === "success") {
                    console.log(res.data.data);
                    
                    setListHistory(res.data.data);
                } else console.log(res.data.message);
            }).catch((err) => console.log(err));
        }
    }, [user, selectID]);

    return (<AkkhorLayout idrole="list-users">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách nhân sự
                </li>
            </ul>
        </div>

        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-sm-3 col-12 form-group">
                            <label>Tên nhân viên </label>
                            <input type="text" placeholder="Tìm theo tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Mã nhân viên </label>
                            <input type="text" placeholder="Tìm theo mã nhân viên" value={code} onChange={(e) => setCode(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Email</label>
                            <input type="text" placeholder="Tìm theo email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="quanlyphep" idrole="list-users" params={params} title="Quản lý phép" defaultLimit={20} serverSide={true} columns={columns}>
        </SRList>

        <Modal show={modalPhep} onHide={() => setModalPhep(false)} animation={true} size="md">
            <Modal.Header closeButton>
                <Modal.Title>Lịch sử</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Họ tên</th>
                            <th>Số phép</th>
                            <th>Phân loại</th>
                            <th>Người thực hiện</th>
                            <th>Ngày thực hiện</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listHistory && listHistory.map(item => {
                            return <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.fullname}</td>
                                <td>{item.point}</td>
                                <td>{item.note}</td>
                                <td>{item.author_name ? item.author_name : "Hệ thống"}</td>
                                <td>{item.datecreate}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-sm btn-secondary" onClick={() => setModalPhep(false)}>Đóng</button>
            </Modal.Footer>

        </Modal>
    </AkkhorLayout>);
}
